import React from 'react';
import { observer } from 'mobx-react';

import Banner from '../../commons/banner/Banner';
import connectLogo from '../../commons/images/icons/connect-logo.svg';
import useMeetConnectBanner from './useMeetConnectBanner';

function MeetConnectBanner() {
    const { showBanner, handleExplore, handleDismiss } = useMeetConnectBanner();

    if (!showBanner) {
        return null;
    }

    return (
        <Banner
            icon={
                <img
                    src={connectLogo}
                    alt="Meet Connect logo"
                    style={{ width: 48, height: 48 }}
                />
            }
            title="Meet Connect"
            actionLabel="Explore"
            onAction={handleExplore}
            actionAriaLabel="Explore Meet Connect"
            onDismiss={handleDismiss}
            dismissAriaLabel="Dismiss Meet Connect banner"
        >
            <strong>Push your ECAL audience</strong>
            {' into the platforms you already use. Over 200 integrations across ESPs, CRMs and CDPs.'}
        </Banner>
    );
}

const ObservedMeetConnectBanner = observer(MeetConnectBanner);

export default ObservedMeetConnectBanner;
